var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head",attrs:{"id":_vm.id}},[_vm._t("title"),_c('span',{staticClass:"subTitle"},[_vm._t("subTitle")],2)],2),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"body"},[_vm._t("body")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }